import useTranslation from 'customHooks/translate';

const NoData = () => {
  const translation = useTranslation();

  return (
    <div className="m-auto mt-[20px] flex flex-col items-center justify-center gap-[20px]">
      <img
        className="h-[100px] w-[200px]"
        src="./assets/no-data.svg"
        alt="no-data"
      />
      <p className="text-[18px] font-medium text-[#1D1D1D]">
        {translation.subusers.noData}
      </p>
    </div>
  );
};

export default NoData;
